import React from 'react';
import {leaderboardConfig, LeaderboardType} from '../config';

export function LeaderboardContainer({type}: {type: LeaderboardType}) {
  const {component: BoardComponent, label} = leaderboardConfig[type];

  return <BoardComponent label={label} />;
}
